import { test } from "../config";
import { Request } from "../request";
import { getURL } from "../utils";
import { realList } from "./real-api";
import { testList } from "./test-api";

const list = test ? testList : realList;

export const getConfig = (code) => {
  return Request.get(getURL(`/api/v1/content/configs/${code}/`));
};

export const API = {
  get: {
    captcha: list.auth.get_captcha,
    credit: list.credit.get_credit,
    export_credit: list.credit.export_credit_excel,
    dashboard: list.dashboard.get_dashboard,
    products: list.products.get_products,
    product: list.products.get_product,
    product_brands: list.products.get_brands,
    product_categories: list.products.get_categories,
    seller_products: list.sellers.get_seller_products,
    export_seller_products: list.sellers.get_export_seller_products,
    sites: list.sites.get_sites,
    provinces: list.company_employee.get_provinces,
    cities: list.company_employee.get_cities,
    drivers: list.drivers.get_company_drivers,
    drivers_report: list.drivers.export_company_drivers,
    company_employee: list.company_employee.get_company_employee,
    company_employee_report: list.company_employee.export_company_employee,
    cars: list.cars.get_cars,
    cars_report: list.cars.export_cars_report,
    company_employee_cars: list.company_employee.get_company_employee_car,
    cars_brands: list.cars.get_cars_brands,
    cars_models: list.cars.get_cars_models,
    buy_product_report: list.order_report.get_order_report,
    export_buy_product_report: list.order_report.export_order_report,
    get_car_services_report: list.cars.get_car_services_report,
    car_services_report: list.cars.export_car_services_report,
    config: getConfig,
  },
  post: {
    login: list.auth.post_login,
    post_seller_product: list.sellers.post_seller_product,
    post_driver: list.drivers.post_company_drivers,
    set_company_employee: list.company_employee.set_company_employee,
    set_company_employee_cities:
      list.company_employee.set_company_employee_cities,
    set_company_employee_car: list.company_employee.set_company_employee_car,
    add_credit: list.credit.add_credit,
    add_car: list.cars.add_car,
  },
  put: {
    put_import_seller_products: list.sellers.put_import_seller_products,
    put_seller_product: list.sellers.put_seller_product,
    put_driver: list.drivers.put_company_drivers,
    put_company_employee: list.company_employee.put_company_employee,
    edit_car: list.cars.edit_car,
  },
};
